import { Box, Image } from "@outschool/backpack";
import { searchPath, toOnlineClassesSlugID } from "@outschool/routes";
import { useTrackEvent } from "@outschool/ui-analytics";
import { Loading, TrackingPage } from "@outschool/ui-legacy-component-library";
import { useIsMobile, useLinkComponent } from "@outschool/ui-utils";
import React, { useEffect } from "react";
import { useHistory, useParams } from "react-router";

import outschoolGlyph from "../../images/Outschool_Logo_Color.svg";
import { useGetPaidClpQuery } from "../components/categories/hooks/usePaidClpQuery";
import PaidCategoryPageBody from "../components/categories/paid/PaidCategoryPageBody";
import SimpleLayout from "../components/layouts/SimpleLayout";
import { DesktopHeaderNavigation } from "../components/nav/DesktopHeaderNav";
import {
  MobileHeaderMenuButton,
  StandardHeader
} from "../components/nav/Header";
import { useUserModeRootPath } from "../lib/UserMode";

export default function PaidCategoryLandingPage() {
  const categoryQuery = useParams<{ themeOrQuery?: string }>()?.themeOrQuery;
  const categorySlug =
    (categoryQuery && toOnlineClassesSlugID(categoryQuery)) || "popular";
  const { loading, categoryPage } = useGetPaidClpQuery(categorySlug!);
  const trackEvent = useTrackEvent();
  const history = useHistory();
  useEffect(() => {
    if (!loading && !categoryPage) {
      trackEvent("paid_clp_to_search_redirected", {
        categorySlug
      });
      history.replace(searchPath({ q: categorySlug?.replace(/-/g, " ") }));
    }
  }, [loading, categoryPage, categorySlug, trackEvent, history]);
  const rootPath = useUserModeRootPath();
  const Link = useLinkComponent();

  const isMobile = useIsMobile();

  if (loading || !categoryPage) {
    return <Loading fullHeight />;
  }

  const headerChildrenRight = isMobile ? (
    <MobileHeaderMenuButton />
  ) : (
    <Box flex sx={{ gap: "1em" }}>
      <DesktopHeaderNavigation />
    </Box>
  );
  return (
    <TrackingPage
      name="paidCategoryPage"
      uniqueId={"paidCategoryPage"}
      filters={categoryPage?.searchFilters}
      uniqueProperties={{
        categorySlug: categorySlug
      }}
    >
      {setImpressionNode => (
        <SimpleLayout
          hideReviewReminder={true}
          showSearchBox={false}
          ref={node => setImpressionNode(node!)}
          customHeader={
            <StandardHeader
              showSearchBox={false}
              hideFindClasses={true}
              leftChildren={
                <Box
                  flex
                  sx={{
                    alignItems: "center",
                    width: "100%",
                    paddingTop: "1em",
                    paddingBottom: "1em"
                  }}
                >
                  <Link
                    to={rootPath}
                    trackingName="nav_logo"
                    reloadDocument
                    style={{ display: "flex" }}
                  >
                    <Image
                      // eslint-disable-next-line i18next/no-literal-string
                      alt="Outschool"
                      height="24px"
                      src={outschoolGlyph}
                    />
                  </Link>
                </Box>
              }
              rightChildren={headerChildrenRight}
              sx={{ backgroundColor: "#f0f3ff", boxShadow: "none" }}
            />
          }
        >
          <Box>
            <PaidCategoryPageBody
              categoryPage={categoryPage}
              categorySlug={categorySlug}
            />
          </Box>
        </SimpleLayout>
      )}
    </TrackingPage>
  );
}
